import React from "react"
import ModalWindow from "../common/ModalWindow";
import ChangePasswordForm from "./ChangePasswordForm";

interface IPropType {
    css: any,
    children:any
}

class ShareChecklistOnMailButton extends React.Component<IPropType, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            showModal: false
        }
    }

    render() {
        const { showModal } = this.state;
        return (
            <React.Fragment>
                {
                    showModal && this.renderModal()
                }
                <button className={this.props.css} onClick={this.onShowModal}>
                    {this.props.children}
                </button>
            </React.Fragment>
        )
    }

    renderModal = () => {
        return (
            <React.Fragment>
                <ModalWindow
                    title="Change Password"
                    backdrop="static"
                    className="modal-md"
                    onCancel={this.onHideModal}
                >
                    <ChangePasswordForm
                        onSubmitComplete={this.onHideModal}
                        onCancel={this.onHideModal}
                    />
                </ModalWindow>
            </React.Fragment>
        )
    }

    onShowModal = (e: any) => {
        this.setState({ showModal: true })
    }

    onHideModal = () => {
        this.setState({ showModal: false })
    }
}

export default ShareChecklistOnMailButton;